<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="editQttBaseUSAModal" persistent max-width="340px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">Update</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeEditQttBaseUSAModal" class="close"><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert :value="seccessAlert" type="success">
                USA Base Quantity Charge updated successfully
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      label="USA Base Quantity Charge*"
                      v-model="editQttBaseUSAData.quantity_charge_base_usa"
                      :error-messages="errors.collect('USA Base Quantity Charge')"
                      v-validate="'required'"
                      data-vv-name="USA Base Quantity Charge"
                      autofocus
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto; margin-right: 20px"
                outline
                color="success"
                >Save</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'seccessAlert',
    'editQttBaseUSAModal',
    'closeEditQttBaseUSAModal',
    'editQttBaseUSAData',
    'editQttBaseUSA'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editQttBaseUSA()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/editQuantityBaseUsa.vue